
















































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';


import store from '../../../store/store';

import { get, post } from "@/util/request";

import { Encrypt, Decrypt} from '../../../util/AES.js'
import getMenus from './successLoginRoutee'
import router from "@/route/router";
import bus from "@/bus";

const userModule = namespace('user');

@Component({
    components: {},
})
export default class PassportLayout extends Vue {


  private rules: any = {
    account: [
      {required: true, message: '请输入用户名', trigger: ['change', 'blur']},
    ],
    password: [
      {required: true, message: '请输入密码', trigger: ['change', 'blur']},
    ]
  }
    private loginForm: any = null;

    private loading: boolean = false;

    private error: string = '';

    private loginModel: any = {
        account: null,
        password: null,
    };

    @userModule.Mutation('loginSuccess')
    private loginSuccess: any;

    constructor() {
        super();
    }

    private created() {
    }

    private mounted() {
    }

    private getRedirect(): string {


        if (!this.$route.query.redirect) {
            return '/';
        }
        const redirect: any = this.$route.query.redirect;
        return redirect;
    }



    private handleLoginSubmit(e: any) {
        e.preventDefault();
      this.$refs.loginForm.validate((valid: any) => {
        if (valid) {
          this.loading = true;
          let password = Encrypt(this.loginModel.password);
          // this.loginModel.account = '404897439'
          // this.loginModel.password = 'gjcuSvl0Pr83X9XZm70v1w=='
          this.$store.state.loginUser=this.loginModel.account
          this.$store.state.loginPsd=password
          post('login', {
            account: this.loginModel.account,
            password: password
          }).then( (res: any) => {
            const resData = res.data;
            if ( resData.code !== 0) {
              this.error = resData.message;
              this.loading = false;
              return;
            }
            this.loginSuccess({token: resData.data.token});
            this.$ss.set('token', resData.data.token);
            sessionStorage.setItem('token',resData.data.token)

            getMenus(this.$ss.get('token'))


            setTimeout(() => {
                const redirect: string = this.getRedirect();
                // store.dispatch('acl/login', {username: resData.data.token});
                if (redirect != null) {
                  this.$router.push(redirect);
                } else {
                  this.$router.push('/');
                }
            },500)


          })
        }
      })

    }

}
